export const getErrorMessage = (err) => {
  if (err.response) {
    return `${err.response.status} ${err.response.statusText}: ${err.response.data["detail"]}`;
  }
  return `${err}`;
};

export const getSessionFilterOptions = (arr) => {
  return arr
    ? [...new Set(arr.map((d) => d["course_name"] + d["session_name"]))]
        .sort()
        .map((d) => {
          return { text: d, value: d };
        })
    : [];
};

export const dateTimeFormat = "YYYY-MM-DD HH:mm:ss";
export const dateFormat = "YYYY-MM-DD";
export const timeFormat = "HH:mm";
